import React, { useCallback, useMemo } from 'react';
import { Trans } from 'react-i18next';

import Spinner from '@common/components/spinner';
import AccessRequestsItem from './access-requests-item';
import { useAccessRequests } from './use-access-requests';
import { useAccessRequestsContext } from '../../contexts/access-requests-context';
import { useParams } from 'react-router-dom';

export const AccessRequestsWidget = () => {
  const { isModalOpen, openModal, closeModal, removeRequest } = useAccessRequestsContext();

  const params = useParams<{ id: string }>();

  const toggleModal = useCallback(() => {
    if (isModalOpen) {
      closeModal();
    } else {
      openModal(params.id);
    }
  }, [isModalOpen, openModal, closeModal, params.id]);

  const {
  accessRequests, loading, isActionLoading, handleApprove, handleReject
  } = useAccessRequests();

  const filteredAccessRequests = useMemo(() => accessRequests.filter((accessRequest) => accessRequest.id !== removeRequest) ?? [],
  [accessRequests, removeRequest]);

  return (
    <div className="balloon">
      <h5 className="balloon__title balloon__title--no-margin">
        <span>
          <Trans i18nKey="social:access_requests" />
        </span>
        <div className="pull-right">
          <a onClick={toggleModal}>
            <Trans i18nKey="social:view_access_requests" />
          </a>
        </div>
      </h5>
      {loading ? (
        <Spinner centered size="large" />
        ) : (
          <>
            {filteredAccessRequests.length > 0 ? (
              filteredAccessRequests.slice(0, 2).map((accessRequest, index) => (
                <AccessRequestsItem
                  userId={accessRequest.user.id}
                  name={accessRequest.user.full_name}
                  image={accessRequest.user.profile_img}
                  hideBorderBottom={index === filteredAccessRequests.length - 1}
                  accessRequestId={accessRequest.id}
                  onApprove={() => handleApprove(accessRequest.id)}
                  onReject={() => handleReject(accessRequest.id)}
                  isActionLoading={isActionLoading}
                />
              ))
            ) : (
              <p className="tw-text-gray-custom-700 tw-text-center tw-mt-[30px]">
                <Trans i18nKey="social:no_access_requests" />
              </p>
            )}
          </>
        )}
    </div>
  );
};
